import { render, staticRenderFns } from "./CarbonBarChart.vue?vue&type=template&id=5ef842bf&"
import script from "./CarbonBarChart.vue?vue&type=script&lang=ts&"
export * from "./CarbonBarChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports